module.exports = __webpack_public_path__ + "static/rocketlink-fab0f8a39d2f79b36f07cc740f613f10.png";